
export const COMPARISON_PROMPT = `你是一位资深的亚马逊数据分析师。请对比分析以下一组关键词，帮助用户筛选出性价比最高、最符合其当前阶段的关键词组合。

# 核心指令
1. **空值处理**：如果某个关键词的部分指标缺失，请基于现有指标进行对比。
2. **多维对比**：请从【流量规模】、【竞争程度】、【转化潜力】三个核心维度进行打分和排序。
3. **场景化推荐**：结合用户的【预算范围】进行推荐。

# 用户需求
- 主要目标: {{user_preference.main_goal}}
- 预算范围: {{user_preference.budget_range}}
- 经验水平: {{user_preference.experience_level}}

{{product_info_section}}

# 关键词数据列表
{{keywords_summary_text}}

# 输出要求
请严格按照以下 JSON 格式输出（不要添加任何额外文字）。

**分析逻辑**：
1. **综合评分**：0-100分。
2. **分类标签**：如 "主力引流"、"高转化长尾"。
3. **优先级排序**：推荐顺序。

\`\`\`json
{
   "comparison_result": [
      {
         "keyword": "关键词文本",
         "score": 85,
         "tags": ["主力引流", "高竞争"],
         "analysis": "简短的对比分析评价",
         "recommendation_level": "High/Medium/Low"
      }
   ],
      "summary_advice": "整体选词策略建议"
}
\`\`\`

请返回 JSON 数据。`;
